import * as L from 'leaflet'
import {MarkerClusterGroup} from 'leaflet.markercluster';

const axios = require('axios');

'use strict';

/*  
Mise à jour de la liste ville :

/location?country=france (Renvoie les villes de France : Paris, Lyon..)



Mise à jour de la liste pays :

/location?ville=paris (Renvoie le pays associé à Paris => France)
*/

const Map =  {
    flexible: null,
    htmlMap: null,
    leafletMap: null, 
    currentAgencies : [],
    currentLocations : [],
    currentPins: [],
    lang: null,
    api : {
        agencies : '/wp-json/advisor/v1/agencies',
        locations : '/wp-json/advisor/v1/location'
    },   
    customIcon: L.divIcon({
        className: "m-pin",
        iconSize : [40, 40],
        iconAnchor: [8, 30],
        labelAnchor: [-6, 0],
        popupAnchor: [0, -36],
        html: `
            <svg xmlns="http://www.w3.org/2000/svg" width="27.007" height="32.182" viewBox="0 0 27.007 32.182">
                <path id="noun-pin-3889019" d="M124.44,20.5a13.5,13.5,0,0,0,0,19.1l8.834,8.834a1.01,1.01,0,0,0,1.428,0l8.834-8.834a13.5,13.5,0,0,0-19.1-19.1Zm3.643,9.2a6.058,6.058,0,1,1,6.058,6.058A6.058,6.058,0,0,1,128.083,29.693Z" transform="translate(-120.485 -16.542)" fill="#0f7364" fill-rule="evenodd"/>
            </svg>
        `
    }),
    customCluster : new MarkerClusterGroup({
        iconCreateFunction: function(cluster) {
            return L.divIcon({
                        className: "map-cluster",
                        iconSize : [40, 40],
                        iconAnchor: [20, 40],
                        //labelAnchor: [-6, 0],
                        //popupAnchor: [0, -36],
                        html: `
                            <svg xmlns="http://www.w3.org/2000/svg" width="27.007" height="32.182" viewBox="0 0 27.007 32.182">
                                <path id="noun-pin-3889019" d="M124.44,20.5a13.5,13.5,0,0,0,0,19.1l8.834,8.834a1.01,1.01,0,0,0,1.428,0l8.834-8.834a13.5,13.5,0,0,0-19.1-19.1Zm3.643,9.2a6.058,6.058,0,1,1,6.058,6.058A6.058,6.058,0,0,1,128.083,29.693Z" transform="translate(-120.485 -16.542)" fill="#0f7364" fill-rule="evenodd"/>
                            </svg>
                            <span>${cluster.getChildCount()}</span>
                        `
                    })
            }, 
        showCoverageOnHover: false,
        maxClusterRadius: 80, 
        //spiderfyOnMaxZoom: false
    }),
    citySelectReset: null,
    isMobile: null,
    params: {
        desktop: {
            zoom : 2.5,
        }, 
        mobile: {
            zoom: 1,
        }
    },

    init: function(){

        // Check device dimension
        Map.isMobile = window.innerWidth < 767;
        window.addEventListener('resize', () => {
            Map.isMobile = window.innerWidth < 767;
            if(Map.leafletMap){
                let params;
                if(Map.isMobile) params = Map.params.mobile
                else params = Map.params.desktop;

                Map.leafletMap.setView([45, 10], params.zoom);
            }
        })

        if (document.querySelector('.f-map')) {
            Map.flexible = document.querySelector('.f-map');
            Map.htmlMap = Map.flexible.querySelector('#map');
            Map.citySelectReset = Map.flexible.querySelector('select[name=cities]').innerHTML
            Map.lang = Map.flexible.dataset.lang
        }
       
        if(Map.htmlMap){
            
            Map.leafletMap = Map.createMap()

            Map
                .fetchAPI(true, {lang: Map.lang})
                .then(() => Map.getPins());

            // Search event
            const searchButton = Map.flexible.querySelector('.c-button');
            
            if(searchButton){
                searchButton.addEventListener('click', Map.submitSearch)
            }

            //Select a country
            const countryFilter = Map.flexible.querySelector('select[name=countries]');
            
            if (countryFilter){
                countryFilter.addEventListener('change', Map.updateCities);
            }

            //Select a city
            const cityFilter = Map.flexible.querySelector('select[name=cities]');
            
            if (cityFilter){
                cityFilter.addEventListener('change', Map.updateCountries);
            }

            //Enable zoom on focus
            Map.leafletMap.once('focus', () => { 
                Map.leafletMap.scrollWheelZoom.enable() 
            });

        }

    }, 

    createMap: function (){
        // Set bounds
        let bounds = L.latLngBounds([[-50,-180],   [80, 200]])

        // Create new map
        const map = L.map('map', {
            zoomControl: false, 
            //bounds,
            scrollWheelZoom: false, 
            zoomSnap: 0.5
        
        })

        // Set view
        let params;
        if(Map.isMobile) params = Map.params.mobile
        else params = Map.params.desktop

        map.setView([35, 10], params.zoom);

        // Add tiles layer
        const layer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', 
            { 
                attributionControl: false,
                maxZoom: 19, 
                minZoom: Map.isMobile ? 1.5 : 2, 
            }
        );
        
        layer.addTo(map)
        
        // Drag event
        map.on('drag', () =>  {
            map.panInsideBounds(bounds, { animate: false });
        })  

        // zoom controls position
        const zoom = new L.Control.Zoom({ position: 'topright' })
        zoom.addTo(map);

        return map
    },
  
    submitSearch : async function (e) {
        const countrySelect = Map.flexible.querySelector('select[name=countries]');
        const citySelect = Map.flexible.querySelector('select[name=cities]');
    
        const params = {
            city : citySelect.value, 
            country : countrySelect.value,
            lang: Map.lang
        }

        Map.fetchAPI(true, params)
            .then(() => {
                if (Map.currentAgencies.length > 0 ){
                    Map.getPins(params);
                    Map.updateList();

                    //If no filter is selected, hide list 
                    if(params.city.length < 1 && params.country.length < 1){
                        Map.flexible.classList.remove('open--')
                    }
                    else {
                        Map.flexible.classList.add('open--')
                    }
                }
                else {
                    Map.flexible.classList.remove('open--')
                }
            })
            .then( () => {
                Map.centerView()
            })      
    }, 
    fetchAPI: async function (fetchAgencies = true, params){ 

        const url = fetchAgencies ? '/wp-json/advisor/v1/agencies' : '/wp-json/advisor/v1/location';

        const data = await axios
            .get(url, {params})
            .catch( (err) => {
                console.log(err)
            })
        
        if(fetchAgencies){
            const agencies = await data.data.agencies;
            const newAgencies = [];

            agencies.forEach(agency => {
                
                // Separate multi locations agenciies into different items
                if(agency.location.length > 1){
                    
                    agency.location.forEach( el => {
                        const loc = {... agency};
                        loc.location = [];
                        loc.location.push(el);

                        if(params.city === undefined || params.country === undefined || (params.city.length < 1 && params.country.length < 1)){
                            newAgencies.push(loc)
                        }
                        else {
                            if(params.city.length > 0 && params.city === el.city.slug && params.country === el.country.slug) newAgencies.push(loc); 
                            else if(params.country.length > 0 && params.city.length === 0 && params.country === el.country.slug) newAgencies.push(loc);
                        }
                    })
                }
                else {
                    newAgencies.push(agency)
                }
            })
            Map.currentAgencies = newAgencies; 
        }
        else {
            const locations = [];
            data.data.forEach(el => {
                locations.push(el.slug)
            })
            Map.currentLocations = locations;
        }
    }, 
    getPins : function (params){
        const locations = Map.currentAgencies

        //Reset
        Map.currentPins = [];

        if(locations.length > 0){

            // Reset
            Map.customCluster.eachLayer((layer) => {
               Map.customCluster.removeLayer(layer)
            })  
            // Add pins
            locations.forEach(loc => {
                if (!isNaN(loc.location[0].latitude) && !isNaN(loc.location[0].longitude)){
                    let pin = L.marker([loc.location[0].latitude, loc.location[0].longitude], {icon: Map.customIcon});
                    Map.customCluster.addLayer(pin)
                    Map.currentPins.push(pin)

                    //Add click event
                    pin.on('click', () => { 
                        Map.selectOnePin(loc, pin) 
                        if(!Map.isMobile) Map.putMapInView()
                    })
                }
            })
            
            Map.leafletMap.addLayer(Map.customCluster);
        }   
    }, 
    updateList: function (){
        const locations = Map.currentAgencies;
        const ul = Map.flexible.querySelector('.f-map__results');
        if (locations.length > 0){
            ul.innerHTML = null;
            locations.forEach( loc => {
                const li = document.createElement('li');
                li.innerHTML = `
                    <a href="${loc.url.url}">
                         <p class="f-map__results-suptitle">${loc.location[0].city.name}, ${loc.location[0].country.name}</p>
                         <h4>${loc.title}</h4>
                         <p class="f-map__results-subtitle">${loc.sector}</p>
                         <span class="f-map__results-url">${loc.url.title}</span>
                    </a>
                `

                ul.appendChild(li);
            })
        }
    }, 
    updateCities: function (e){

        //Reset 
        const citySelect = Map.flexible.querySelector('select[name=cities]');
        citySelect.innerHTML = null;
        citySelect.innerHTML = Map.citySelectReset

        const cityOptions = citySelect.querySelectorAll('option')
        cityOptions[0].selected = true;

        const params = {
            country: e.target.value,
            lang: Map.lang
        }

        //If a country has been selected, fetch API and update cities
        if(params.country.length > 0){

            Map.fetchAPI(false, params).then( () => {
                
                //Hide unwanted cities
                cityOptions.forEach(option => {
                    
                    if(!Map.currentLocations.includes(option.value) && option.value.length > 0){
                        citySelect.removeChild(option)
                    }
                })
            })
        }
    }, 
    updateCountries: function (e){

        const countrySelect = Map.flexible.querySelector('select[name=countries]');
        const countryOptions = countrySelect.querySelectorAll('option')        

        const params = {
            city: e.target.value, 
            lang: Map.lang
        }

        //Reset 
        countryOptions[0].selected = true;

        //If a city has been selected, fetch API and update the country
        if(params.city.length > 0){
            document.querySelector('.f-map .c-button').disabled = true;
            Map.fetchAPI(false, params).then( () => {

                countryOptions.forEach(option => {
                    //Select the matching country
                    if(Map.currentLocations.includes(option.value)){
                        if(Map.currentLocations.length === 1){
                            option.selected = true;
                        }
                    }
                })
                document.querySelector('.f-map .c-button').disabled = false;
            })
        }
    }, 
    updateFilters: function (city, country){

        //Reset cities 
        //Reset 
        const citySelect = Map.flexible.querySelector('select[name=cities]');
        citySelect.innerHTML = null;
        citySelect.innerHTML = Map.citySelectReset
        
        const countryOptions = Map.flexible.querySelector('select[name=countries]').children;
        const cityOptions = Map.flexible.querySelector('select[name=cities]').children;

        for (let opt of cityOptions){
            opt.selected = false;
            if(opt.value === city) opt.selected = true
        }

        for (let opt of countryOptions){
            opt.selected = false;
            if(opt.value === country) opt.selected = true
        }
    },
    selectOnePin:  function (location, pin){
        //Update list
        Map.currentAgencies = [];
        Map.currentAgencies.push(location);
        Map.updateList()
        Map.flexible.classList.add('open--')

        //Update filters...
        Map.updateFilters(location.location[0].city.slug, location.location[0].country.slug)
        
        //Center view
        Map.currentPins = [];
        Map.currentPins.push(pin);
        Map.centerView(true)

    }, 
    centerView: function(uniquePin = false){
        //Center on current Pins
        if(uniquePin){
            let lat = Map.currentPins[0]._latlng.lat
            let lng = Map.currentPins[0]._latlng.lng
            Map.leafletMap.setView([lat,lng])
        }
        else {
            const group = new L.featureGroup(Map.currentPins);
            Map.leafletMap.fitBounds(group.getBounds(), {maxZoom: 6});     
        }
    },
    putMapInView: function (){
        const mapPositionTop = Map.flexible.offsetTop;
        const mapPositionBottom = mapPositionTop + Map.flexible.clientHeight;

        const headerHeight = document.querySelector('.header').clientHeight;
        const topScrollPos = window.scrollY + headerHeight;
        const bottomScrollPos = topScrollPos + window.innerHeight - headerHeight;

        if(topScrollPos > mapPositionTop || bottomScrollPos < mapPositionBottom) {
            window.scrollTo({
                top: mapPositionTop - headerHeight, 
                behavior: 'smooth'
            })
        }
    }
};


export default Map;


// WEBPACK FOOTER //
// ./src/scripts/components/Map.js